import React from 'react';

/**
 * Primary button component with brand red styling
 * @param {Object} props - Component props
 * @param {string} props.text - Button text to display
 * @param {Function} props.onClick - Click handler function
 * @param {string} [props.className] - Additional class names
 * @param {boolean} [props.disabled] - Whether the button is disabled
 * @param {React.ReactNode} [props.children] - Optional children to render instead of text
 */
export const PrimaryBtn = ({ 
  text, 
  onClick, 
  className = '', 
  disabled = false, 
  children,
  ...props 
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center rounded-md border border-transparent bg-brand-red-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-brand-red-600 focus:outline-none focus:ring-2 focus:ring-brand-red-400 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {children || text}
    </button>
  );
};

/**
 * Secondary button component with light styling
 * @param {Object} props - Component props
 * @param {string} props.text - Button text to display
 * @param {Function} props.onClick - Click handler function
 * @param {string} [props.className] - Additional class names
 * @param {boolean} [props.disabled] - Whether the button is disabled
 * @param {React.ReactNode} [props.children] - Optional children to render instead of text
 */
export const SecondaryBtn = ({ 
  text, 
  onClick, 
  className = '', 
  disabled = false,
  children,
  ...props 
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`rounded-md bg-white dark:bg-gray-800 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 ${className}`}
      {...props}
    >
      {children || text}
    </button>
  );
};

export default {
  PrimaryBtn,
  SecondaryBtn
};
